export default defineNuxtRouteMiddleware(() => {
	usei18nService()?.getLocaleLang()
})
